
<script>
export default {
  name: 'LogListItem',
  props: {
    log: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
    };
  },
};
</script>

<template>
  <tr :style="'color:' + (
    log.errorMessages && log.errorMessages.length > 0 ? '#D32F2F' : (
      log.warningMessages && log.warningMessages.length > 0 ? '#FFA000' : '#26a73a'
    )
  )">
    <td>{{ (log.errorMessages && log.errorMessages.length > 0 ? 'nein' : 'ja') }}</td>
    <td>{{ log.name }}</td>
    <td>{{ log.errorMessages }}</td>
    <td>{{ log.warningMessages }}</td>
  </tr>
</template>
